<!--
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2023-09-05 10:49:22
 * @LastEditors: DESKTOP-ROEB53E\caiyangjie 1760178806@qq.com
 * @LastEditTime: 2024-02-05 09:50:57
 * @FilePath: \合联\oms\src\view\finances\storageFeeNew\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    ref="table"
  >
  </cTable>
</template>

<script>
import cTable from "@/base/common/index";
import { apis, exportApi } from "@/api/finance/storageFeeNew";
import {getCustomer, getOwnership} from "@/api/public";
import { getCompanies } from "@/api/user/client";
import { header } from "../../order/order-template/header";
import moment, { duration } from "moment";
export default {
  name: "storageFeeNew",
  components: {
    cTable
  },
  props: {
    branch: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      methods: {
        ...apis,
        list: params => {
          if (this.branch) {
            params.is_branch = 1;
          } else {
            params.is_hq = 1;
          }
          return apis.list(params);
        }
      },
      config: {
        branch: this.branch
      },
      footer: {},
      modals: {
        info: {
          config: {
            title: this.$tz("详情"),
            modalBind: {
              width: 1000
            },
            listFn: "info"
          },
          footer: {
            show: () => false
          },
          table: {
            config: {
              height: 600
            },
            footer: {
              show: () => true
            },
            fields: [
              {
                name: () => this.$tz("计费,日期"),
                key: "date",
                minWidth: 110
              },
              {
                name: () => this.$tz("仓库"),
                key: "warehouse",
                minWidth: 110
              },
              {
                name: () => this.$tz("SKU,个数"),
                key: "number",
                minWidth: 110
              },
              {
                name: () => this.$tz("SKU,计费,个数"),
                key: "charge_number",
                minWidth: 110
              },
              {
                name: () => this.$tz("SKU,计费,单价"),
                key: "number_price",
                minWidth: 110
              },
              {
                name: () => this.$tz("SKU,计费,金额"),
                key: "number_fee",
                minWidth: 110
              },
              {
                name: () => this.$tz("库位,体积"),
                key: "volume",
                minWidth: 110
              },
              {
                name: () => this.$tz("库位,计费,体积"),
                key: "charge_volume",
                minWidth: 110
              },
              {
                name: () => this.$tz("库位,计费,单价"),
                key: "volume_price",
                minWidth: 110
              },
              {
                name: () => this.$tz("库位,计费,金额"),
                key: "volume_fee",
                minWidth: 110
              },
              {
                name: () => this.$t("operation"),
                type: "btns",
                width: 320,
                fixed: "right",
                list: [
                  {
                    name: this.$tz("SKU,详情"),
                    type: "info",
                    fnName: "info",
                    bind: {
                      type: "info"
                    },
                    id: [1829, 1834]
                  },
                  {
                    name: this.$tz("导出详情"),
                    type: "success",
                    fnName: "export",
                    bind: {
                      type: "success"
                    },
                  }
                ],
                methods: {
                  info({ row }) {
                    let modal = this.getModal("info");
                    this.getModal("sku").open(row, function() {
                      this.pageConfig.data = {
                        client_id: modal.params.client_id,
                        warehouse_id: modal.params.warehouse_id,
                        report_date: row.report_date,
                        target_type: modal.params.target_type,
                        is_branch: this.config.branch ? 1 : 0,
                        is_hq: !this.config.branch ? 1 : 0
                      };
                      this.getList();
                    });
                  },
                  export({ row }) {
                    let modal = this.getModal("info"),
                      exportParams = {
                        client_id: modal.params.client_id,
                        warehouse_id: modal.params.warehouse_id,
                        report_date: row.report_date,
                        target_type: modal.params.target_type,
                        is_branch: this.config.branch ? 1 : 0,
                        is_hq: !this.config.branch ? 1 : 0
                      }
                    this.$Spin.show()
                    // 想OMS请求
                    exportApi(exportParams).then(response => {
                      this.$Spin.hide()
                      if (response.data.status) {
                        window.open(response.data.payload);
                      } else {
                        this.$Message.warning(response.data.msg)
                      }
                    }).catch(e => {
                      this.$Spin.hide()
                      this.$Message.error(e.message)
                    })
                  }
                }
              }
            ]
          }
        },
        sku: {
          config: {
            title: this.$tz("SKU,详情"),
            modalBind: {
              width: 1000
            },
            listFn: "sku"
          },
          footer: {
            show: () => false
          },
          table: {
            config: {
              height: 600
            },
            footer: {
              show: () => true
            },
            fields: [
              {
                name: () => this.$tz("日期"),
                key: "date",
                minWidth: 110
              },
              {
                name: () => this.$tz("仓库"),
                key: "warehouse",
                minWidth: 110
              },
              {
                name: () => this.$tz("库位"),
                key: "location",
                minWidth: 110
              },
              {
                name: () => this.$tz("商品名称"),
                key: "goods_name",
                minWidth: 110
              },
              {
                name: () => this.$tz("SKU"),
                key: "sku",
                minWidth: 110
              },
              {
                name: () => this.$tz("数量"),
                key: "quantity",
                minWidth: 110
              },
              {
                name: () => this.$tz("体积重量"),
                key: "volume_weight",
                minWidth: 110
              },
              {
                name: () => this.$tz("上架时间"),
                key: "history",
                minWidth: 130,
                render(h, { row }) {
                  return h('div', {}, row.history.inboundTime)
                }
              },
              {
                name: () => this.$tz("计费开始时间"),
                key: "history",
                minWidth: 130,
                render(h, { row }) {
                  return h('div', {}, row.history.chargeTime)
                }
              },
              {
                name: () => this.$tz("计费类型"),
                key: "history",
                minWidth: 130,
                render(h, { row }) {
                  return h('div', {}, row.history.chargeUnit || '-')
                }
              },
              {
                name: () => this.$tz("计费单价"),
                key: "history",
                minWidth: 130,
                render(h, { row }) {
                  return h('div', {}, row.history.chargePrice || '-')
                }
              },
              {
                name: () => this.$tz("计费数量"),
                key: "history",
                minWidth: 130,
                render(h, { row }) {
                  return h('div', {}, row.history.chargeValue || '-')
                }
              },
              {
                name: () => this.$tz("计费金额"),
                key: "history",
                minWidth: 130,
                render(h, { row }) {
                  return h('div', {}, row.history.chargeFees)
                }
              }
            ]
          }
        }
      },
      header: {
        searchs: [
          {
            key: "month",
            placeholder() {
              return this.$tz("请选择,开始,日期");
            },
            disabledDate: true,
            component: "DatePicker",
            format: "YYYY-MM",
            bind: {
              type: "month"
            }
          },
          {
            key: "warehouse_id",
            placeholder() {
              return this.$tz("仓库");
            },
            component: "Select",
            options: [],
            optionsFn: "getWarehouse",
            optionsKey: ""
          },
          {
            key: "target_type",
            placeholder() {
              return this.$tz("客户,类型");
            },
            component: "Select",
            show: () => !this.branch,
            options: [
              {
                label: this.$t("b2bClient"),
                value: 1
              },
              {
                label: this.$t("branchOffice"),
                value: 2
              }
            ],
            methods: {
              "on-change"({ searchForm }) {
                searchForm.client_id = "";
              }
            }
          },

          {
            key: "client_id",
            placeholder() {
              return this.$tz("客户名称");
            },
            show: ({ searchForm }) => {
              return searchForm.target_type === 1 || this.branch;
            },
            component: "SelectSearchable",
            options: [],
            config: { label: "label", value: "value" },
            methods: {
              'remote-method'({ field, $event }) {
                if ($event.length >= 3) {
                  getCustomer({ keywords: $event }).then(res => {
                    this.$nextTick(() => {
                      field.options = res.data.payload || [];
                      this.$forceUpdate()
                    })
                  });
                } else {
                  field.options = [];
                }
              }
            }
          },

          {
            key: "client_id",
            placeholder() {
              return this.$tz("公司名称");
            },
            show: ({ searchForm }) => {
              return searchForm.target_type === 2;
            },
            component: "SelectSearchable",
            options: [],
            config: { label: "label", value: "value" },
            methods: {
              'remote-method'({ field, $event }) {
                if ($event.length >= 3) {
                  getOwnership({ keywords: $event }).then(res => {
                    this.$nextTick(() => {
                      field.options = res.data.payload || [];
                      this.$forceUpdate()
                    })
                  });
                } else {
                  field.options = [];
                }
              },
            }
          },

          {
            key: "sale_id",
            placeholder() {
              return this.$tz("销售名称");
            },
            component: "Select",
            options: [],
            optionsFn: "Input",
            optionsKey: ""
          }
        ],
        btns: {
          list: [
            {
              name: this.$t("export"),
              btnBind: {
                type: "primary"
              },
              list: [
                {
                  name: this.$tz("列表数据"),
                  type: "export",
                  fnName: "export",
                  disabled() {
                    return !this.selectAll.length;
                  }
                },
                {
                  name: this.$tz("明细数据"),
                  type: "detail",
                  fnName: "export"
                }
              ]
            },
            {
              name: () => this.$tz("创建账单"),
              type: "bill",
              fnName: "bill",
              bind: {
                type: "primary"
              },
              // id: 1828
            }
          ],
          methods: {
            export({ searchForm, field }) {
              if (field.type === "export") {
                this.exportExc();
              } else
                this.handleRequestMethods(
                  "list",
                  Object.assign(
                    {
                      export: 1,
                      is_branch: this.config.branch ? 1 : 0,
                      is_hq: !this.config.branch ? 1 : 0
                    },
                    searchForm
                  ),
                  false,
                  true
                ).then(res => {
                  this.$Message["success"]({
                    background: true,
                    content: "请到导出管理下载",
                    duration: 5
                  });
                });
            },
            bill({ searchForm }) {
              this.$Modal.confirm({
                title: this.$tz("创建账单"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods(
                    "create_bill",
                    Object.assign(
                      {
                        is_branch: this.config.branch ? 1 : 0,
                        is_hq: !this.config.branch ? 1 : 0
                      },
                      searchForm
                    ),
                    true,
                    true
                  ).then(res => {
                    this.getList();
                  });
                }
              });
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60,
          fixed: "left"
        },
        {
          name: () => this.$tz("月份"),
          key: "month",
          minWidth: 110
        },
        {
          name: () => this.$tz("客户名称"),
          key: "account",
          minWidth: 110
        },
        {
          name: () => this.$tz("销售名称"),
          key: "sale_name",
          minWidth: 110
        },
        {
          name: () => this.$tz("公司名称"),
          key: "company",
          minWidth: 110
        },
        {
          name: () => this.$tz("优选合同抬头"),
          key: "contract",
          minWidth: 110
        },
        {
          name: () => this.$tz("账单金额"),
          key: "amount",
          minWidth: 110
        },
        {
          name: () => this.$tz("仓库"),
          key: "warehouse",
          minWidth: 110
        },
        {
          name: () => this.$tz("SKU"),
          children: [
            {
              name: () => this.$tz("个数"),
              key: "number",
              minWidth: 100
            },
            {
              name: () => this.$tz("单价"),
              key: "number_price",
              minWidth: 110
            },
            {
              name: () => this.$tz("金额"),
              key: "number_fee",
              minWidth: 100
            }
          ]
        },
        {
          name: () => this.$tz("库位"),
          children: [
            {
              name: () => this.$tz("体积"),
              key: "volume",
              minWidth: 100
            },
            {
              name: () => this.$tz("单价"),
              key: "volume_price",
              minWidth: 110
            },
            {
              name: () => this.$tz("金额"),
              key: "volume_fee",
              minWidth: 110
            }
          ]
        },
        {
          name: () => this.$tz("总金额"),
          key: "total_fee",
          minWidth: 110
        },
        {
          name: () => this.$t("operation"),
          type: "btns",
          width: 220,
          fixed: "right",
          list: [
            {
              name: this.$tz("详情"),
              type: "info",
              fnName: "info",
              bind: {
                type: "info"
              },
              id: [1830, 1835]
            }
          ],
          methods: {
            info({ row }) {
              this.getModal("info").open(row, function() {
                this.pageConfig.data = {
                  client_id: row.client_id,
                  warehouse_id: row.warehouse_id,
                  month: row.month,
                  target_type: row.target_type,
                  is_branch: this.config.branch ? 1 : 0,
                  is_hq: !this.config.branch ? 1 : 0
                };
                this.getList();
                this.setTitle(row.account);
              });
            }
          }
        }
      ]
    };
  }
};
</script>

<style scoped></style>
